module.exports = __webpack_public_path__ + "img/format_2.e0ee1aae.png";